// extracted by mini-css-extract-plugin
module.exports = {"root":"mainNavigation_root__1Vox8"};